// Module
var code = "<div class=\"fpd-scroll-area\"> <div class=\"fpd-grid fpd-grid-cover fpd-photo-grid\"></div> </div>";
// Exports
module.exports = code;